import React, { useEffect, useRef, useState } from "react";
import { Check, Plus, Send, User } from "lucide-react";
import Select from "react-select";
import { notify, countSegments, can_visit, userAccessToken } from "../../helpers";
import { Config } from "../../Config";
import axios from "axios";
import { Link } from "react-router-dom";
import { getLetterLimitData } from "../../services/letter";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function LetterModal(props) {
  const {
    last_name = "",
    first_name = "",
    address = "",
    messageTemplate = [],
    account_id,
    location_id,
    activeModal,
    setActiveModal = () => { },
    setLetterLimit = () => { },
    previousScrollPosition = 0,
  } = props;

  const [formData, setFormData] = useState({
    account_id: account_id,
    letter_template: "",
    message: "",
    patient_address: address,
    location_id: location_id,
    letter_type: "Regular_Mail",
    patient_name: last_name + " " + last_name
  });
  const [segments, setSegments] = useState(0);
  const [chooseTemplate, setChooseTemplate] = useState(null);
  const dropdownRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "message") {
      setFormData({
        ...formData,
        [name]: value,
      });
      setSegments(countSegments(value));
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const getLetterLimit = async () => {
    const result = await getLetterLimitData(account_id);
    if (result) {
      setLetterLimit(result?.data);
    } else {
      setLetterLimit(0);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.patient_address === null) {
      notify("error", "Invalid Address");
    } else {
      try {
        e.target.disabled = true;
        const response = await axios.post(Config.notificationServerUrl + "/letter-transaction/send-letter", formData,
          {
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${userAccessToken()}`,
            },
          }
        );

        if (response) {
          setFormData({
            ...formData,
            message: "",
          });
          notify("success", "Letter Send to " + response.data.patient_address);

          e.target.disabled = false;
          handleDrawerClose();
          setTimeout(() => {
            getLetterLimit();
          }, 5000);
        }
      } catch (error) {
        notify("error", "Letter not sent, Please check your settings!");
        e.target.disabled = false;
      }
    }
  };

  const allMessageTemplate = messageTemplate?.map((option) => ({
    value: option?.id,
    label: option?.title,
  }));

  const handleTemplateChange = (selectedOption) => {
    const selectedTemplateId = selectedOption.value;
    setChooseTemplate(selectedTemplateId);
    const selectedTemplate = messageTemplate.find(
      (template) => template.id === parseInt(selectedTemplateId)
    );
    if (selectedTemplate) {
      let messageBody = selectedTemplate.body;
      let updateMessageBody = messageBody
        .replace("[last_name]", last_name)
        .replace("[first_name]", first_name);

      setFormData({
        ...formData,
        message_body: updateMessageBody,
      });
      setSegments(countSegments(updateMessageBody));
    }
  };

  useEffect(() => {
    setFormData({
      ...formData,
      location_id: location_id,
      account_id: account_id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id]);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 large">
            <Drawer.Title className="sr-only">Send Letter</Drawer.Title>
            <Drawer.Description className="sr-only">Send letter of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">
              {can_visit("_send_letter") && (
                <div className="docpro_modal">
                  <form onSubmit={handleSubmit} className="modal_height_100">
                    <div>
                      <h2 className="docpro_fs_24 docpro_mb_0">Send a Letter</h2>
                      <Spacing lg="20" sm="20" />
                      {(last_name + first_name).length >= 2 && (
                        <>
                          <label className="docpro_fw_500 docpro_primary_color">
                            Patient Name
                          </label>
                          <div className="docpro_form_field_with_icon">
                            <input
                              name="full_name"
                              type="text"
                              defaultValue={last_name + " " + first_name}
                              className="docpro_form_field size_lg"
                              readOnly
                            />
                            <User
                              width={20}
                              height={20}
                              className="docpro_form_field_icon"
                            />
                            <Check
                              width={20}
                              height={20}
                              className="docpro_form_field_icon"
                            />
                          </div>
                          <Spacing lg="20" sm="20" />
                        </>
                      )}

                      <label className="docpro_fw_500 docpro_primary_color">
                        Patient Address <span className="docpro_red_color">*</span>
                      </label>
                      <div>
                        <input
                          type="text"
                          name="patient_address"
                          className="docpro_form_field"
                          onChange={handleChange}
                          value={address ? address : formData.patient_address}
                        />
                      </div>

                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Letter Type <span className="docpro_red_color">*</span>
                      </label>
                      <div className="flex">
                        <label htmlFor="regular_mail" className="mr-4">
                          <input
                          type="radio"
                          id="regular_mail"
                          name="letter_type"
                          value="Regular_Mail"
                          checked={formData.letter_type === "Regular_Mail"}
                          onChange={handleChange}
                          className="mr-2"
                        />
                          Regular Mail
                        </label>
                        <label htmlFor="certified_mail">
                        <input
                          type="radio"
                          id="certified_mail"
                          name="letter_type"
                          value="Certified_Mail"
                          checked={formData.letter_type === "Certified_Mail"}
                          onChange={handleChange}
                          className="mr-2"
                        />
                          Certified Mail
                        </label>
                      </div>

                      <Spacing lg="20" sm="20" />
                      <div className="docpro_label_group">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Template
                        </label>
                        <Link to="/message-templates" className="docpro_text_btn_2">
                          <Plus width={16} height={16} />
                          Create new template
                        </Link>
                      </div>
                      <Select
                        options={allMessageTemplate}
                        placeholder="Search Template..."
                        isSearchable
                        value={allMessageTemplate?.find((option) => option?.value === chooseTemplate) || null}
                        onChange={handleTemplateChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                      <Spacing lg="20" sm="20" />

                      <label className="docpro_fw_500 docpro_primary_color">
                        Message <span className="docpro_red_color">*</span>
                      </label>
                      <textarea
                        required
                        minLength={2}
                        name="message"
                        className="docpro_form_field size_lg"
                        cols="30"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Write your message here..."
                      ></textarea>
                      {/* <div>
                        Total segments:{" "}
                        <span className="docpro_badge docpro_badge_success">
                          {segments}
                        </span>
                      </div> */}
                      <Spacing lg="20" sm="20" />
                    </div>
                    <button
                      type="submit"
                      className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn docpro_mt_auto"
                    >
                      <Send width={20} height={20} />
                      <span>Send Letter</span>
                    </button>
                  </form>
                </div>
              )}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
